import env from "./envConfig";

export const signalRConfig = {
    baseURL: env.REACT_APP_SERVICE_URL,
    baseHubUrl: `${env.REACT_APP_SERVICE_URL_FRAMEWORK}/`,
    overrideConnection: env.REACT_APP_SIGNALR_CONNECTION
}